import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingInfoButton from './components/FloatingInfoButton';
import HomePage from './pages/HomePage';
import ImpressumPage from './pages/ImpressumPage';
import DatenschutzPage from './pages/DatenschutzPage';
import AirfieldInfoPage from './pages/AirfieldInfoPage';
import { CookieProvider } from './contexts/CookieContext';
import CookieBanner from './components/CookieBanner';

function App() {
  return (
    <CookieProvider>
      <BrowserRouter>
        <div className="App">
          <a href="#main-content" className="skip-to-content">Zum Inhalt springen</a>
          <Header />
          <main id="main-content">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/flugplatzinfo" element={<AirfieldInfoPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
          </main>
          <FloatingInfoButton />
          <Footer />
          <CookieBanner />
        </div>
      </BrowserRouter>
    </CookieProvider>
  );
}

export default App;
